import { Builder, Fetcher, TranslateFunction, Translations } from '@dynamic/ui';
import styled from 'styled-components';

import { Button } from '#/components/Button/Button';
import { TextBoxSelect } from '#/components/TextBoxSelect/TextBoxSelect';
import { FontsDetails } from '#/service/config/common.types';
import { FormFactors } from '#/service/constants';
import { tb } from '#/store/translation/translation.store';

import { dynuiFetcher } from '../dynui-fetchers';

export interface BuildDynamicUiParams {
  fontConfig: FontsDetails;
  translations: Translations;
  parentalSystem: string | undefined;
  hoverCardsEnabled: boolean;
  formFactor: FormFactors;
  v2Templates: any;
  // optional. uses `dynuiFetcher` by default.
  customFetcher?: Fetcher;
}

const StyledButton = styled(Button)`
  padding: 0;
`;

const translate: TranslateFunction = (value, opts) => {
  return tb(value, opts);
};

export const buildDynamicUi = ({
  fontConfig,
  translations,
  parentalSystem,
  hoverCardsEnabled,
  formFactor,
  v2Templates,
  customFetcher,
}: BuildDynamicUiParams) => {
  const { Page, Container, Item } = new Builder()
    .setButtonBase(StyledButton)
    .setFontConfig(fontConfig)
    .setTranslations(translations)
    .setTranslationMethod(translate)
    .setParentalSystem(parentalSystem)
    .setHoverCardsEnabled(hoverCardsEnabled)
    .setFetcher(customFetcher ?? dynuiFetcher)
    .setFormFactor(formFactor)
    .setV2Templates(v2Templates)
    .setSelectComponent(TextBoxSelect)
    .build();

  return {
    Page: Page,
    Container: Container,
    Item: Item,
  };
};
